module.exports = __webpack_public_path__ + "img/assemblageGlasSmall.0452142f.jpg";